import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, BarChart3, Users, Activity } from 'lucide-react';
import Icon from '../AppIcon';


const NAV_ITEMS = [
  {
    label: 'Operations',
    icon: LayoutDashboard,
    path: '/ipm-operations-overview',
  },
  {
    label: 'Treatment',
    icon: Activity,
    path: '/treatment-analytics',
  },
  {
    label: 'Team',
    icon: Users,
    path: '/team-performance-hub',
  },
  {
    label: 'Analytics',
    icon: BarChart3,
    path: '/predictive-analytics-dashboard',
  },
];

const DashboardBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg md:hidden">
      <div className="flex items-stretch h-16">
        {NAV_ITEMS?.map((item) => {
          const Icon = item?.icon;
          const isActive = location?.pathname === item?.path;
          return (
            <button
              key={item?.path}
              onClick={() => navigate(item?.path)}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 min-h-[44px] touch-manipulation transition-colors active:bg-gray-100 ${
                isActive
                  ? 'text-green-600' :'text-gray-500 hover:text-gray-700'
              }`}
              aria-label={item?.label}
            >
              <Icon
                className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-green-600' : 'text-gray-500'}`}
              />
              <span className={`text-xs font-medium leading-none ${isActive ? 'text-green-600' : 'text-gray-500'}`}>
                {item?.label}
              </span>
              {isActive && (
                <span className="absolute bottom-0 w-8 h-0.5 bg-green-600 rounded-t-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default DashboardBottomNav;
